import { ajax } from '../../../services/helper'
class ApiService {

    getWorkLocationsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workLocations/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addWorkLocations = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workLocations/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getWorkLocationsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workLocations/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editWorkLocations = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/workLocations/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Work Locations/services/apiservices.js